/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_ePulse/assets/ts/components'
import {KTSVG} from '../../../../../../../../_ePulse/helpers'
import {useNavigate} from 'react-router-dom'
import useLocalStorageFetch from '../../../../../../../../hooks/localStorageFetch'
import {ToastMessageContainer} from '../../../../../../../../_ePulse/layout/components/ToastMessageContainer'
import {Modal} from 'react-bootstrap'
import {success} from '../../../../../../../../data/Status/success'
import {toast} from 'react-toastify'
import useMutationApi from '../../../../../../../../hooks/useMutation'
import {CANCEL_APPOINTMENT} from '../../../../../GraphQLQueries/Dashboard'
import {checkPermission} from '../../../../../../../App'

const CancelCell = (props: any) => {
  const navigate = useNavigate()
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const {role} = useLocalStorageFetch()
  const [modalState, setmodalState] = useState(false)
  const [isLoading, setLoading] = useState(false)

  const {
    createData,
    loading: cancelAppointmentLoading,
    error: cancelAppointmenterror,
    data: cancelAppointmentData,
  } = useMutationApi(CANCEL_APPOINTMENT)

  const onHandleCancelAppointment = async (appointment: any) => {
    try {
      setLoading(true)
      await createData({
        appointmentId: appointment.id,
        status: 'Cancelled',
      })
      toast.success(success.APPOINTMENT_CANCELED_SUCCESSFULLY)
      props.refetch()
      setmodalState(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const appointment = props.tableProps

  return (
    <div className='d-flex ms-5'>
      {modalState && (
        <div>
          <ToastMessageContainer />
          <Modal
            show={modalState}
            dialogClassName='ePulse-modal ePulse-modal-50w'
            onHide={() => setmodalState(false)}
            backdrop='static'
          >
            <Modal.Header closeButton>
              <span className='fs-3 fw-bold'>Cancel Appointment</span>
            </Modal.Header>
            <Modal.Body className='container'></Modal.Body>
            <div className='ePulse-modal-content'>
              <div className='bg-white rounded p-3 '>
                <span>Are you sure you want to cancel appointment?</span>
              </div>

              <div className='btn-row'>
                <button
                  className='ePulse-btn-primary'
                  type='button'
                  onClick={() => onHandleCancelAppointment(appointment)}
                >
                  Yes
                </button>
                <button
                  className='ePulse-btn-secondory ms-2'
                  type='button'
                  onClick={() => {
                    setmodalState(false)
                    props.refetch()
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}
      {appointment.isPrescriptionSent === false &&
      checkPermission('changeDoctorAppointmentStatus') ? (
        <div className='d-flex flex-row col justify-content-center'>
          <div className='d-flex flex-row align-items-center justify-content-center'>
            <button
              onClick={() => {
                setmodalState(true)
              }}
              className='menu-link px-3 text-dark border-0 bg-white text-decoration-underline'
            >
              <KTSVG path='/media/ePulse/icons/Delete_cross.svg' className='delete-icon' />
            </button>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export {CancelCell}
